import store from '../redux/store';
import type { Address } from '../1_types/genericTypes';
import { logMediumError } from '../utils/logger';
import { getClosestShopsFromRedux } from '../utils/shop';
import { ORDER_TYPE_DELIVERY } from '../constants/order';
import { API_AVAILABLE_SHOPS, API_DIRECTIONS_FROM_COORDINATES } from './api';
import { sendGetRequest } from './backend';

const addressToParams = (address: Address): Record<string, string | object> => {
	const { street, streetNumber, city, postalCode, location } = address;
	const params: Record<string, string | object> = {};
	if (street) params.street = street;
	if (streetNumber) params.streetNumber = streetNumber;
	if (city) params.city = city;
	if (postalCode != null) params.postalCode = String(postalCode);
	const lat = Number(location?.latitude);
	const lng = Number(location?.longitude);
	if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
		params.location = { latitude: lat, longitude: lng };
	}
	return params;
};

export const getAvailableShops = async (
	orderType: string,
	address?: Address | null
): Promise<any[]> => {
	const { companyId } = store.getState().configurationReducer;
	try {
		const params = { orderType, ...(address ? addressToParams(address) : {}) };
		const response = await sendGetRequest(
			API_AVAILABLE_SHOPS(companyId),
			params,
			false
		);
		const shops = response.data ?? [];
		return Array.isArray(shops) ? shops : [];
	} catch (error) {
		try {
			if (orderType !== ORDER_TYPE_DELIVERY) {
				return getClosestShopsFromRedux(orderType, address);
			}
		} catch (fallbackErr) {
			logMediumError(
				`Fallback for available-shops failed ${fallbackErr}`,
				{ orderType }
			);
		}
		logMediumError(
			`Failed to get available shops from company (${companyId}) ${error}`,
			{ orderType, address }
		);
		throw error;
	}
};

export const getDirectionsBetweenCoordinates = async (
	companyId: string,
	latitudeOrigin: number,
	longitudeOrigin: number,
	latitudeDestination: number,
	longitudeDestination: number
) => {
	const response = await
		sendGetRequest(
			API_DIRECTIONS_FROM_COORDINATES(companyId),
			{
				latitudeOrigin,
				longitudeOrigin,
				latitudeDestination,
				longitudeDestination,
			},
			false
		);
	return response;
};
